/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pause': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M181.333 0H74.667c-17.643 0-32 14.357-32 32v448c0 17.643 14.357 32 32 32h106.667c17.643 0 32-14.357 32-32V32c-.001-17.643-14.358-32-32.001-32zM437.333 0H330.667c-17.643 0-32 14.357-32 32v448c0 17.643 14.357 32 32 32h106.667c17.643 0 32-14.357 32-32V32c-.001-17.643-14.358-32-32.001-32z"/>'
  }
})
